import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import './style.css';

export default function Home() {
  const [isNavSticky, setIsNavSticky] = useState(false);
  const [lastScrollPosition, setLastScrollPosition] = useState(0);

  const navigate = useNavigate(); // Get the navigate function

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollX || window.pageYOffset;
      const offsets = {
        Home: 0,
        About: 500,
        Skills: 1000,
        Work: 1500,
        Contact: 2000,
      };

      let activeSection = 'Home';
      for (const section in offsets) {
        if (scrollY >= offsets[section]) {
          activeSection = section;
        }
      }

      if (scrollY > lastScrollPosition) {
        setIsNavSticky(true);
      } else {
        setIsNavSticky(false);
      }

      setLastScrollPosition(scrollY);

      // Automatically update the URL when scrolling
      // navigate(`#${activeSection}`);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [lastScrollPosition, navigate]);

  const navContentClassName = isNavSticky ? 'nav-content active-sticky' : 'nav-content';

  return (
    <div className='home-container' id='Home'>
      <div  id="nav-content" className={navContentClassName}>
        <ul style={{ color: "#063dcc" }}>
          <li className='dhome'><a href="#Home">Home</a></li>
          <li className='dabout'><a href="#About">About</a></li>
          <li className='dskills'><a href="#Skills">Skills</a></li>
          <li className='dwork'><a href="#Work">Work</a></li>
          <li className='dcontact'><a href="#Contact">Contact</a></li>
        </ul>
        <span className='logo ' style={{ color: "#063dcc" }}>/asfer</span>
      </div>
      <div className='home-body'>
        <h1>Hello, I’m Asfer</h1>
        <h1> – an web developer &</h1>
        <h1>designer / focus on</h1>
        <h1>Design & Branding.</h1>
      </div>
    </div>
  );
}
